import React from 'react'
import { Text } from '@mantine/core'

export const SectionLabel = (props: { children: React.ReactNode }) => {
  const { children } = props
  return (
    <Text size="xs" fw={700} tt="uppercase" style={{ letterSpacing: '0.1em', color: 'var(--mantine-color-dimmed)' }}>
      {children}
    </Text>
  )
}
